const packageName = process.env._PACKAGE_NAME_ as string;
const packageVersion = process.env._PACKAGE_VERSION_ as string;
export function getPackageInfo() {
	return {
		packageName,
		packageVersion,
	};
}
